import { CompanyNode, DepartmentNode } from 'features/common/models';
import { useContext, useEffect, useState } from 'react';
import { Collapse, Form, ListGroup } from 'react-bootstrap';
import { getDepartmentKey, getDirectChilds, getParent, isCompanyNode } from 'utils';
import { DepartmentMenuContext } from '..';
import { SquareMinusIcon, SquarePlusIcon } from '../icons';

export interface DepartmentMenuItemProps {
  data: DepartmentNode | CompanyNode;
}

export function DepartmentMenuItem({ data }: DepartmentMenuItemProps) {
  const branchKey = getDepartmentKey(data);

  const departmentMenuContext = useContext(DepartmentMenuContext);
  const isExpandable = data.departments && data.departments.length > 0;
  const organizationData = departmentMenuContext.organizationData;

  //state
  const [open, setOpen] = useState(true);
  const [isSelected, setIsSelected] = useState(
    departmentMenuContext.path.some((pathMenu) => {
      return pathMenu.some((pathItem) => pathItem.id === branchKey.id && pathItem.cd === branchKey.cd);
    })
  );

  const isMenuSelected = departmentMenuContext.activeDepartmentKeys?.some(
    (key) => key.id === branchKey.id && key.cd === branchKey.cd
  );

  function unCheckedDirectParentDepartment(clickedElementChecked: boolean, branchKeyId: number, branchKeyCd: string) {
    if (!clickedElementChecked) {
      const parentNode = getParent(organizationData, branchKeyId, branchKeyCd);
      if (parentNode) {
        const selector = isCompanyNode(parentNode)
          ? `#branch-${parentNode.company_id}-${parentNode.company_cd} > button .form-check-input`
          : `#branch-${parentNode.department_id}-${parentNode.department_cd} > button .form-check-input`;
        const chkParentElement = document.querySelector<HTMLInputElement>(selector);
        if (chkParentElement) chkParentElement.checked = false;
        if (!isCompanyNode(parentNode)) {
          unCheckedDirectParentDepartment(clickedElementChecked, parentNode.department_id, parentNode.department_cd);
        }
      } else {
        return;
      }
    }
  }

  function getSelectedDepartmentOnRestaurant(clickedElementChecked: boolean, branchKeyId: number, branchKeyCd: string) {
    unCheckedDirectParentDepartment(clickedElementChecked, branchKeyId, branchKeyCd);
    return [data as DepartmentNode];
  }

  function getSelectedDepartmentOnUnit(clickedElementChecked: boolean, branchKeyId: number, branchKeyCd: string) {
    unCheckedDirectParentDepartment(clickedElementChecked, branchKeyId, branchKeyCd);

    let restaurantChilds = getDirectChilds(organizationData, branchKeyId, branchKeyCd) as DepartmentNode[];
    let targetRestaurantChilds: DepartmentNode[] = restaurantChilds;

    if (clickedElementChecked) {
      targetRestaurantChilds = restaurantChilds.filter((departmentChild: DepartmentNode) => {
        if (isCompanyNode(departmentChild)) {
          return !departmentMenuContext.activeDepartmentKeys?.some(
            (activeDepartmentKey) =>
              activeDepartmentKey.id === departmentChild.company_id &&
              activeDepartmentKey.cd === departmentChild.company_cd
          );
        } else {
          return !departmentMenuContext.activeDepartmentKeys?.some(
            (activeDepartmentKey) =>
              activeDepartmentKey.id === departmentChild.department_id &&
              activeDepartmentKey.cd === departmentChild.department_cd
          );
        }
      });
    }

    targetRestaurantChilds.forEach((department) => {
      const selector = isCompanyNode(department)
        ? `#branch-${department.company_id}-${department.company_cd} > button .form-check-input`
        : `#branch-${department.department_id}-${department.department_cd} > button .form-check-input`;
      const chkBranchElement = document.querySelector<HTMLInputElement>(selector);
      if (chkBranchElement) chkBranchElement.checked = !chkBranchElement.checked;
    });

    return targetRestaurantChilds;
  }

  function getSelectedDepartmentOnBlock(clickedElementChecked: boolean, branchKeyId: number, branchKeyCd: string) {
    let targetRestaurantChilds: DepartmentNode[] = [];

    let departmentChilds = getDirectChilds(organizationData, branchKeyId, branchKeyCd) as DepartmentNode[];
    if (departmentChilds) {
      const firstChild = departmentChilds[0];
      let isUnit = false;
      if (firstChild.classification === 'U') {
        isUnit = true;
      }

      if (isUnit) {
        departmentChilds.forEach((departmentChild) => {
          const selector = `#branch-${departmentChild.department_id}-${departmentChild.department_cd} > button .form-check-input`;
          const chkBranchElement = document.querySelector<HTMLInputElement>(selector);
          if (chkBranchElement) {
            if (clickedElementChecked) {
              if (!chkBranchElement.checked) {
                chkBranchElement.checked = true;
                const targetRestaurants = getSelectedDepartmentOnUnit(
                  clickedElementChecked,
                  departmentChild.department_id,
                  departmentChild.department_cd
                );
                targetRestaurantChilds = targetRestaurantChilds.concat(targetRestaurants);
              }
            } else {
              chkBranchElement.checked = false;
              const targetRestaurants = getSelectedDepartmentOnUnit(
                clickedElementChecked,
                departmentChild.department_id,
                departmentChild.department_cd
              );
              targetRestaurantChilds = targetRestaurantChilds.concat(targetRestaurants);
            }
          }
        });
      } else {
        const targetRestaurants = getSelectedDepartmentOnUnit(clickedElementChecked, branchKeyId, branchKeyCd);
        targetRestaurantChilds = targetRestaurantChilds.concat(targetRestaurants);
      }
    }

    return targetRestaurantChilds;
  }

  function getSelectedDepartmentOnArea(clickedElementChecked: boolean, branchKeyId: number, branchKeyCd: string) {
    let targetRestaurantChilds: DepartmentNode[] = [];

    let departmentChilds = getDirectChilds(organizationData, branchKeyId, branchKeyCd) as DepartmentNode[];
    if (departmentChilds) {
      departmentChilds.forEach((departmentChild) => {
        const selector = `#branch-${departmentChild.department_id}-${departmentChild.department_cd} > button .form-check-input`;
        const chkBranchElement = document.querySelector<HTMLInputElement>(selector);
        if (chkBranchElement) {
          if (clickedElementChecked) {
            if (!chkBranchElement.checked) {
              chkBranchElement.checked = true;
              const targetRestaurants = getSelectedDepartmentOnBlock(
                clickedElementChecked,
                departmentChild.department_id,
                departmentChild.department_cd
              );
              targetRestaurantChilds = targetRestaurantChilds.concat(targetRestaurants);
            }
          } else {
            chkBranchElement.checked = false;
            const targetRestaurants = getSelectedDepartmentOnBlock(
              clickedElementChecked,
              departmentChild.department_id,
              departmentChild.department_cd
            );
            targetRestaurantChilds = targetRestaurantChilds.concat(targetRestaurants);
          }
        }
      });
    }

    return targetRestaurantChilds;
  }

  function getSelectedDepartmentOnCompany(clickedElementChecked: boolean, branchKeyId: number, branchKeyCd: string) {
    let targetRestaurantChilds: DepartmentNode[] = [];

    let departmentChilds = getDirectChilds(organizationData, branchKeyId, branchKeyCd) as DepartmentNode[];
    if (departmentChilds) {
      departmentChilds.forEach((departmentChild) => {
        const selector = `#branch-${departmentChild.department_id}-${departmentChild.department_cd} > button .form-check-input`;
        const chkBranchElement = document.querySelector<HTMLInputElement>(selector);
        if (chkBranchElement) {
          if (clickedElementChecked) {
            if (!chkBranchElement.checked) {
              chkBranchElement.checked = true;
              const targetRestaurants = getSelectedDepartmentOnArea(
                clickedElementChecked,
                departmentChild.department_id,
                departmentChild.department_cd
              );
              targetRestaurantChilds = targetRestaurantChilds.concat(targetRestaurants);
            }
          } else {
            chkBranchElement.checked = false;
            const targetRestaurants = getSelectedDepartmentOnArea(
              clickedElementChecked,
              departmentChild.department_id,
              departmentChild.department_cd
            );
            targetRestaurantChilds = targetRestaurantChilds.concat(targetRestaurants);
          }
        }
      });
    }

    return targetRestaurantChilds;
  }

  function handleMenuClick(e: React.MouseEvent<HTMLButtonElement>) {
    const chkElement = e.currentTarget.querySelector<HTMLInputElement>('.chk-selected-department > input');
    if (chkElement) {
      chkElement.checked = !chkElement.checked;

      let targetRestaurantChilds: DepartmentNode[] = [];

      if (data.classification === 'T') {
        targetRestaurantChilds = getSelectedDepartmentOnRestaurant(chkElement.checked, branchKey.id, branchKey.cd);
      } else if (data.classification === 'U') {
        targetRestaurantChilds = getSelectedDepartmentOnUnit(chkElement.checked, branchKey.id, branchKey.cd);
      } else if (data.classification === 'B') {
        targetRestaurantChilds = getSelectedDepartmentOnBlock(chkElement.checked, branchKey.id, branchKey.cd);
      } else if (data.classification === 'A') {
        targetRestaurantChilds = getSelectedDepartmentOnArea(chkElement.checked, branchKey.id, branchKey.cd);
      } else if (data.classification === null || data.classification === '') {
        targetRestaurantChilds = getSelectedDepartmentOnCompany(chkElement.checked, branchKey.id, branchKey.cd);
      }

      if (targetRestaurantChilds.length > 0) {
        departmentMenuContext.toggleSelectedDepartment &&
          departmentMenuContext.toggleSelectedDepartment(targetRestaurantChilds);
      }
    }
  }

  function handleToggleCollapse() {
    setOpen(!open);
  }

  useEffect(() => {
    setIsSelected(
      departmentMenuContext.path.some((pathMenu) => {
        return pathMenu.some((pathItem) => pathItem.id === branchKey.id && pathItem.cd === branchKey.cd);
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departmentMenuContext]);

  const MenuItemRoot = (
    <ListGroup.Item
      id={`branch-${branchKey.id}-${branchKey.cd}`}
      className={`${isExpandable ? 'dt-parent' : ''} ${isSelected ? 'isSelected' : ''} ${open ? 'isOpen' : ''} ${
        isMenuSelected ? 'menu-selected' : ''
      }`}
    >
      {!isCompanyNode(data) && isExpandable && (
        <div className="branch-icon" onClick={handleToggleCollapse}>
          {open ? (
            <SquareMinusIcon width={14} height={16} color={isSelected && isMenuSelected ? 'white' : 'black'} />
          ) : (
            <SquarePlusIcon width={14} height={16} color={isSelected && isMenuSelected ? 'white' : 'black'} />
          )}
        </div>
      )}

      {!isCompanyNode(data) ? (
        <button className="branch-name d-flex align-items-center w-100" onClick={handleMenuClick}>
          <Form.Check
            type="checkbox"
            className="chk-selected-department"
            id={`selected-department-${branchKey.id}-${branchKey.cd}`}
            defaultChecked={isMenuSelected}
            disabled
            label={``}
          />
          <span className="branch-link">{isCompanyNode(data) ? data.company_name : data.department_name}</span>
        </button>
      ) : (
        <button className="branch-name d-none d-flex align-items-center w-100">
          <span className="branch-link">{data.company_name}</span>
        </button>
      )}
    </ListGroup.Item>
  );

  const MenuItemChildren = isExpandable ? (
    <Collapse in={open}>
      <ListGroup>
        {data.departments?.map((item) => (
          <DepartmentMenuItem key={isCompanyNode(item) ? item.company_cd : item.department_cd} data={item} />
        ))}
      </ListGroup>
    </Collapse>
  ) : null;

  if ((data.departments === undefined || data.departments.length === 0) && data.classification !== 'T') {
    return null;
  }

  return (
    <>
      {MenuItemRoot}
      {MenuItemChildren}
    </>
  );
}
